import { fetchExperienceById } from 'actions/ExperienceActions'
import React, { useContext, useEffect } from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import ExperienceOfferPageContent from './ExperienceOfferPageContent'
import ExperienceOfferPageLoadingSkeleton from './ExperienceOfferPageLoadingSkeleton'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import Error500Page from 'components/Pages/Error500Page'
import { useParams } from 'react-router'
import RedirectWithStatus from 'components/Common/RedirectWithStatus/RedirectWithStatus'
import { getExperienceOfferPageURL } from 'lib/offer/offerPageURL'
import ExperienceOfferPageStateProvider from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateProvider'
import useExperiencePageReducer from 'hooks/ExperiencePage/useExperiencePageReducer'
import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import ModalProvider from 'contexts/ModalProvider'
import GeoContext from 'contexts/geoContext'
import useExperience from 'hooks/Experiences/useExperience'
import useEuropeOfferPageWalledGarden from 'hooks/OfferPage/useEuropeOfferPageWalledGarden'

function ExperienceOfferPage() {
  const { id, slug } = useParams<{ id: string, slug: string }>()
  const [experience,, error] = useExperience(id)
  const [state, stateDispatch] = useExperiencePageReducer(experience)
  const { currentRegionCode } = useContext(GeoContext)
  const dispatch = useAppDispatch()

  useEuropeOfferPageWalledGarden()

  useEffect(() => {
    dispatch(fetchExperienceById(id))
  }, [dispatch, id])

  if (error) {
    if (error.status === 404) {
      return <Error404PageWithOffers />
    }

    return <Error500Page />
  }

  if (experience && (experience.slug !== slug)) {
    return <RedirectWithStatus code={301} to={`/${currentRegionCode.toLowerCase()}${getExperienceOfferPageURL(experience)}`} />
  }

  return <AnalyticsPageContext.Provider value={AnalyticsPage.offerPage}>
    <div>
      {!experience && <ExperienceOfferPageLoadingSkeleton />}
      {experience && <ExperienceOfferPageStateProvider state={state} dispatch={stateDispatch}>
        <ModalProvider>
          <ExperienceOfferPageContent experience={experience} />
        </ModalProvider>
      </ExperienceOfferPageStateProvider>
      }
    </div>
  </AnalyticsPageContext.Provider>
}

export default ExperienceOfferPage
